import React from "react";
import { isNil, pick } from "lodash";
import { Redirect } from "react-router";
import { z } from "zod";
import { buildLink, getPath } from "common/routing";
import { stripInvalidCharacters } from "common/utils/strings";
import { useGetOrCreateGuestPropertyQuery } from "../../generated/graphql";
import useURLParsing from "../../hooks/useURLParsing";

const parser = z.object({
  address: z.string().transform(stripInvalidCharacters).nullish(),
  lat: z.coerce.number().nullish(),
  lng: z.coerce.number().nullish(),
  parcelNumber: z.string().transform(stripInvalidCharacters).nullish(),
});

export default () => {
  const parsedParams = useURLParsing({
    routeName: "residentPropertyRedirect",
    parser,
  });

  const params = pick(parsedParams || {}, [
    "address",
    "lat",
    "lng",
    "parcelNumber",
  ]);

  const missingParams = Object.values(params).some(isNil);
  const noParamsProvided = Object.values(params).every(isNil);

  const { data, error, loading } = useGetOrCreateGuestPropertyQuery({
    variables: {
      address: params.address!,
      latitude: params.lat!,
      longitude: params.lng!,
      parcelNumber: params.parcelNumber,
      improveParcelCoordinates: false,
    },
    skip: missingParams || noParamsProvided,
  });

  if (loading) {
    return null;
  }

  if (noParamsProvided) {
    return (
      <Redirect
        from={getPath("residentPropertyRedirect")}
        to={getPath("explore")}
      />
    );
  }

  if (missingParams) {
    return (
      <Redirect
        from={getPath("residentPropertyRedirect")}
        to={getPath("noProperty")}
      />
    );
  }

  if (error || !data?.getProperty) {
    return (
      <Redirect
        from={getPath("residentPropertyRedirect")}
        to={getPath("noProperty")}
      />
    );
  }

  return (
    <Redirect
      from={getPath("residentPropertyRedirect")}
      to={buildLink("residentProperty", {
        propertyId: data.getProperty.id,
      })}
    />
  );
};
